var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("application.title"))),
            ]),
            _vm._v(" "),
            _c("v-select", {
              attrs: {
                options: _vm.titleOptions,
                reduce: (option) => option.code,
                searchable: false,
                name: "title",
                fieldValue: _vm.title,
                fieldTitle: _vm.t("application.title", {}, "zh"),
                fieldname: "title",
                required: "",
              },
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
          _c("label", { staticClass: "inbox-label required" }, [
            _vm._v(_vm._s(_vm.t("application.mobile"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.mobile,
                expression: "mobile",
              },
            ],
            staticClass: "form-control",
            attrs: {
              fieldTitle: _vm.t("application.contact_mobile", {}, "zh"),
              id: "mobile",
              fieldname: "mobile",
              type: "tel",
              name: "mobile",
              fieldType: "mobile",
              "field-attrs": "unique",
              maxlength: "8",
              minlength: "8",
              required: "",
            },
            domProps: { value: _vm.mobile },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.mobile = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-sm-6" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }